export const FEATURE_FLAGS_STORAGE_KEY = 'featureFlags';
